import axios from 'axios'

export default class SchedulingService {
  static async deleteFailureStatus (job) {
    await axios
      .delete(`${process.env.VUE_APP_INTERNAL_API_BASEURL}/scheduling/${job}/failure`)
  }
}